module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid12_800x704.4f80ce1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid12_800x704.jpg
// module id = j/YM
// module chunks = 0